import React, { ReactElement } from 'react';
import 'antd/dist/antd.css';
import { BrowserRouter, Switch } from 'react-router-dom';
import HomePage from './pages/homepage';
import LoginPage from './pages/login';
import PublicRoute from './components/AuthenticationRoute/PublicRoute';
import PrivateRoute from './components/AuthenticationRoute/PrivateRoute';

function App(): ReactElement {
  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute exact component={LoginPage} path="/login" />
        <PrivateRoute component={HomePage} exact={false} path="/" />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
